import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { DateRange, extractDateRange, extractDefaultStoreId, extractNumber, HxReportService, toRouterQueryParams, UserReceivedOrderModel } from 'hx-services';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Отчёт по продажам
 */
@Component({
    selector: 'app-user-received-order.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './user-received-order.component.html',
    styleUrls: ['./user-received-order.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, NgIf, NgFor, HxLoaderComponent, DatePipe, TranslocoPipe]
})
export class UserReceivedOrderComponent implements OnInit, OnDestroy {
  list: UserReceivedOrderModel[] = [];
  params: { date?: DateRange, storeId?: number } = {};
  isLoading = {
    list: false
  };
  private sub: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private errorService: ErrorHandlerService,
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap);
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      if (this.params.storeId) {
        this.loadList();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private loadList() {
    this.list = [];
    this.isLoading.list = true;
    this.reportService.getUserReceivedOrder(this.params).subscribe(response => {
      this.list = response;
      this.isLoading.list = false;
    }, error => {
      this.isLoading.list = false;
      this.errorService.handler(error);
    });
  }
}
